




import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class VIcon extends Vue {
  @Prop({ required: true }) src!: string;
  @Prop({ default: "" }) alt!: string;
  @Prop() title!: string;

  click(e: MouseEvent) {
    this.$emit("click", e);
  }
}

export interface IconProps {
  key?: string;
  src: string;
  alt?: string;
  title?: string;
}
